// EVENTS.COMPONENTS.APPLICATION.REWARDS.REDEEM.VIEW_REWARD.REWARD_LICENSE

export const REWARD_LICENSE = {
  TAB_VIEWED: 'license-tab_viewed'
};
